<template>
    <div>
        <span v-if="booking.vehicle_presence_status !== BookingPresenceStatuses.CUSTOMER" class="badge badge-success" style="text-transform: capitalize;">{{ booking.vehicle_presence_status_text }}</span>
        <span v-if="booking.vehicle_presence_status !== BookingPresenceStatuses.CUSTOMER && booking.vehicle_key_number" class="badge badge-success" style="text-transform: capitalize;">
            <span class="material-icons" style="font-size: .9rem; vertical-align: middle; line-height: .5rem;">vpn_key</span> {{ booking.vehicle_key_number }}
        </span>
        <span v-if="booking.requires_courtesy_car" class="badge badge-info badge-icon" style="color: #fff; cursor: pointer;" @click="navigateToReservation">
            <span class="material-icons">link</span>
            <span>Courtesy Car</span>
        </span>
        <span v-if="isCustomerWaiting" class="badge badge-danger">Customer Waiting</span>
        <span v-if="hasWarrantyItems" class="badge badge-warning">Warranty</span>
    </div>
</template>

<style scoped lang="scss">
    .badge {
        vertical-align: middle;

        &.badge-icon {
            padding: 0 0.4em;
            span {
                vertical-align: middle;
                &.material-icons { font-size: 1rem; }
            }
        }
    }
</style>

<script>
    import Moment from 'moment'
    import { BookingPresenceStatuses } from '../../classes/Api/Booking'

    export default {
        props: ['booking'],
        data() {
            return {
                BookingPresenceStatuses
            }
        },
        methods: {
            navigateToReservation() {
                let startOfWeek = Moment(this.booking.calendar_entry.from)
                    .startOf('isoWeek')
                    .format('YYYY-MM-DD')

                this.$root.navigateTo(
                    'courtesy-cars/?starting=%s#!/booking/%s',
                    [startOfWeek, this.booking.reservation.id]
                );
            }
        },
        computed: {
            isCustomerWaiting() {
                let diff = Moment(this.booking.calendar_entry.to).diff(this.booking.calendar_entry.from, 'days', true)

                if (0 === diff) {
                    return true
                }

                return false
            },
            hasWarrantyItems() {
                return this.booking.tasks && this.booking.tasks.filter(t => {
                    return t.is_warranty_claim
                }).length > 0
            }
        }
    }
</script>